module.exports = __webpack_public_path__ + "static/media/281091.22b5cc9f.png";